import { httpClient } from '../httpClient/httpClient';

export interface Currency {
  id: number;
  branchId: number;
  code: string;
  name: string;
  sellingRate: number;
  buyingRate: number;
  archived?: boolean;
}

export interface CurrencyRequest {
  name: string;
  code: string;
  sellingRate: number;
  buyingRate: number;
  archived: boolean;
}

export interface CustomerCurrency {
  id: number;
  branchId: number;
  code: string;
  name: string;
  sellingRate: number;
  buyingRate: number;
  garpSellingRate: number;
  sellingRateModified: boolean;
}

export const currenciesApi = {
  getAllCurrencies: () => httpClient.get<Currency[]>(`currencies/all`),
  getAllCurrenciesMergedWithCustomerCurrencies: (customerId: number) =>
    httpClient.get<CustomerCurrency[]>(`currencies/all/merged/${customerId}`),
  getForBranch: (branchId: number) =>
    httpClient.get<Currency[]>(`branches/${branchId}/currencies`),
  create: (branchId: number, request: CurrencyRequest) =>
    httpClient.post<Currency>(`branches/${branchId}/currencies`, {
      data: request,
    }),
  update: (id: number, request: CurrencyRequest) =>
    httpClient.put<Currency>(`currencies/${id}`, { data: request }),
};
